import { type NoExtra } from "@jti/fe-common";

import { GTMEVARunner } from "../runners";

import { TrackingEvent } from "./TrackingEvent";
import type { TrackingEvents, TrackingEventsAdditionalData } from "./types";

const createTrackingEvent = <
  EventName extends TrackingEvents,
  Additional = EventName extends keyof TrackingEventsAdditionalData ? TrackingEventsAdditionalData[EventName] : never,
>(
  eventName: EventName,
  additionalData: Additional
): TrackingEvent<EventName, Additional> => {
  return new TrackingEvent(eventName, {
    detail: {
      additionalData,
    },
  });
};

// this overload is to cover situation when additionalData is not provided with maintaining check for cases where data is needed
// for more information check tests
export function dispatchTrackingEvent<
  EventName extends TrackingEvents,
  Additional extends (EventName extends keyof TrackingEventsAdditionalData
    ? TrackingEventsAdditionalData[EventName]
    : never),
  T,
>(
  eventName: EventName,
  ...additionalData: Additional extends undefined ? [] : [NoExtra<T, Additional>]
): Promise<void | false>;
export function dispatchTrackingEvent<
  EventName extends TrackingEvents,
  Additional extends (EventName extends keyof TrackingEventsAdditionalData
    ? TrackingEventsAdditionalData[EventName]
    : never),
>(eventName: EventName, additionalData?: Additional): Promise<void | false> {
  const event = createTrackingEvent(eventName, additionalData);
  if (typeof document === "undefined") {
    return Promise.resolve();
  }

  GTMEVARunner.dispatchEvent(event);
  return new Promise((resolve) => setTimeout(resolve, 500));
}
